import FederatedPhotoError from './FederatedPhotoError';

const LayoutPhoto = ({ id = '', url = '', errorDto = {} } = {}) => ({
  id: String(id),
  url: String(url),
  errorDto: FederatedPhotoError(errorDto),
});

export default LayoutPhoto;

export type LayoutPhotoProps = ReturnType<typeof LayoutPhoto>;
